export default __webpack_public_path__ + "static/media/cambodia.85bf9098.mp3";